import { Globe, Users } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PollVisibility } from '@/types/polls';

interface VisibilityToggleProps {
  value: PollVisibility;
  onChange: (value: PollVisibility) => void;
  disabled?: boolean;
}

export function VisibilityToggle({ value, onChange, disabled }: VisibilityToggleProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-foreground">
        Visibility
      </label>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onChange('public')}
          disabled={disabled}
          className={cn(
            "flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all",
            value === 'public'
              ? "border-primary bg-primary/10 text-primary"
              : "border-border bg-surface-2 text-muted-foreground hover:border-muted-foreground/50",
            disabled && "opacity-50 cursor-not-allowed"
          )}
        >
          <Globe className="w-4 h-4" />
          <span className="font-medium text-sm">Community</span>
        </button>
        <button
          type="button"
          onClick={() => onChange('private')}
          disabled={disabled}
          className={cn(
            "flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all",
            value === 'private'
              ? "border-primary bg-primary/10 text-primary"
              : "border-border bg-surface-2 text-muted-foreground hover:border-muted-foreground/50",
            disabled && "opacity-50 cursor-not-allowed"
          )}
        >
          <Users className="w-4 h-4" />
          <span className="font-medium text-sm">Friends only</span>
        </button>
      </div>
      <p className="text-xs text-muted-foreground">
        {value === 'public' 
          ? "Everyone in the community can vote on your poll"
          : "Only friends you select can see and vote on this poll"
        }
      </p>
    </div>
  );
}
